export class AdExtension {
  constructor() {
    this.attributes = {};
    this.children = [];
  }
}
